module.exports = __webpack_public_path__ + "static/media/drone.906c4d68.svg";